import { useEffect, useState } from "react";
import { Mail, Check, Bell } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { TownChips } from "./TownChips";

export const SignupBox = ({ towns, all }) => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("");
  const [err, setErr] = useState("");
  const [alertsOn, setAlertsOn] = useState([]);
  const [touched, setTouched] = useState(false);
  const [request, setRequest] = useState("");
  const options = all.filter((t) => !t.family);
  const compared = towns.map((t) => t.slug).filter((s) => options.some((o) => o.slug === s)).join();
  useEffect(() => { if (!touched) setAlertsOn(compared ? compared.split(",") : []); }, [compared, touched]);
  const submit = async (e) => {
    e.preventDefault();
    setState("busy"); setErr("");
    try {
      await api.post("/public/subscribe", { email, towns: towns.map((t) => t.town), slugs: towns.map((t) => t.slug), alert_slugs: alertsOn, request_town: request });
      setState("done");
    } catch (x) { setErr(errMsg(x)); setState(""); }
  };
  return (
    <section data-testid="calc-signup" className="border border-[#E2D9CC] bg-[#F4EFE6] p-6 sm:p-10 space-y-6">
      <div className="grid md:grid-cols-[1fr_auto] gap-6 items-end">
        <div>
          <p className="eyebrow mb-2 flex items-center gap-2"><Mail className="w-4 h-4" />Free updates</p>
          <h2 className="font-display text-3xl text-[#3B1B48]">Get new towns, price alerts and a monthly market snapshot</h2>
          <p className="text-sm text-[#6B5B4E] mt-2 max-w-xl">We'll send you a free sample chapter for each town you're comparing, a short monthly market snapshot, and an alert when prices in the towns you pick move 5% or more. No spam, unsubscribe any time.</p>
        </div>
        {state === "done" ? (
          <p data-testid="calc-signup-done" className="flex items-center gap-2 text-[#2D6A4F]"><Check className="w-5 h-5" />You're on the list{alertsOn.length ? `, watching ${alertsOn.length} town${alertsOn.length === 1 ? "" : "s"}` : ""}. Thank you.</p>
        ) : (
          <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2" id="calc-signup-form">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" data-testid="calc-signup-email"
              className="h-12 w-72 max-w-full px-4 bg-white border border-[#E2D9CC] outline-none focus:border-[#3B1B48]" />
            <button type="submit" disabled={state === "busy"} data-testid="calc-signup-submit" className="h-12 px-6 bg-[#3B1B48] text-[#FAF7F2] text-sm hover:bg-[#2A1334] transition-colors disabled:opacity-60">{state === "busy" ? "Signing up…" : "Sign me up"}</button>
            {err && <p data-testid="calc-signup-error" className="text-xs text-red-700 sm:w-full">{err}</p>}
          </form>
        )}
      </div>
      {state !== "done" && options.length > 0 && (
        <div className="border-t border-[#E2D9CC] pt-5" data-testid="calc-signup-alerts">
          <p className="text-sm text-[#3B1B48] mb-3 flex items-center gap-2"><Bell className="w-4 h-4 text-[#C59B27]" />Alert me when prices move 5%+ in: <span className="text-[#8C827A]">({alertsOn.length} picked)</span></p>
          <TownChips towns={options} picked={alertsOn} onChange={(v) => { setTouched(true); setAlertsOn(v); }} />
          <label className="block mt-5 text-sm text-[#3B1B48]">Is there a town you'd like a guide for? <span className="text-[#8C827A]">(optional)</span>
            <input form="calc-signup-form" value={request} onChange={(e) => setRequest(e.target.value)} maxLength={80} placeholder="e.g. Anghiari, Tuscany" data-testid="calc-signup-request"
              className="block mt-1.5 h-11 w-80 max-w-full px-4 bg-white border border-[#E2D9CC] outline-none focus:border-[#3B1B48]" />
          </label>
        </div>
      )}
    </section>
  );
};
